














































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Form, Message } from 'element-ui'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import { FundMemberDetail, Debit, FundType, FundMemberDetailRequest } from '@/api/model/cash'
import $Api from '@api'
import { translate, DateTime } from '@/utils/filters'
import { finalize } from 'rxjs/operators'

const fundTypeOption: { label: string; value: FundType }[] = [
    {
        label: translate('cash.tableData.fundType.tenant'),
        value: FundType.TENANT
    },
    {
        label: translate('cash.tableData.fundType.personal'),
        value: FundType.PERSONAL
    },
    {
        label: translate('cash.tableData.fundType.cash'),
        value: FundType.CASH
    }
]

const debitOption: { label: string; value: Debit }[] = [
    {
        label: translate('cash.tableData.debit.add'),
        value: Debit.ADD
    },
    {
        label: translate('cash.tableData.debit.reduce'),
        value: Debit.REDUCE
    }
]

@Component({
    components: {
        SearchForm,
        TableForm
    },
    filters: {
        transformFundType(fundType: FundType) {
            switch (fundType) {
                case FundType.TENANT:
                    return translate('cash.tableData.fundType.tenant')
                case FundType.PERSONAL:
                    return translate('cash.tableData.fundType.personal')
                case FundType.CASH:
                    return translate('cash.tableData.fundType.cash')
                default:
                    return fundType
            }
        }
    }
})
export default class extends Vue {
    fundTypeOption = fundTypeOption
    debitOption = debitOption
    dateTime = DateTime
    tableData: FundMemberDetail[] = []
    shouldTableDateLoading: boolean = false
    total = 0

    searchForm: { [key: string]: any } = {
        current: 1,
        size: 10,
        accountId: null,
        cameraId: null
    }

    created(): void {
        this.getData()
    }

    getData(pageQuery?: object): void {
        if (pageQuery) {
            Object.assign(this.searchForm, pageQuery)
        }
        this.shouldTableDateLoading = true
        $Api.cashService
            .fundMemberDetailPage(this.searchForm as FundMemberDetailRequest)
            .pipe(
                finalize(() => {
                    this.shouldTableDateLoading = false
                })
            )
            .subscribe(res => {
                this.tableData = res.records
                this.total = res.total
            }, err => {
                this.$message.error(err.message)
                this.tableData = []
            })
    }

    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    reset(formName): void {
        ;(this.$refs[formName] as Form).resetFields()
    }
}
